// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Ev-2","delete":"styles_delete__1ug3r","update":"styles_update__1SM5e","add":"styles_add__FiFD7"};